import { c as _c } from "react/compiler-runtime";
import { Calendar } from '@byway/icons';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Notification } from '~/components/Notification';
import useJourneyData from '~/hooks/useJourneyData';
const inspirationLink = (chunks: ReactNode) => <a className="underline underline-offset-2" href="https://www.byway.travel/inspiration/last-minute-trips">
    {chunks}
  </a>;
const contactLink = (href: string) => (chunks: ReactNode) => <a target="_blank" className="underline" href={href} rel="noreferrer">
    {chunks}
  </a>;
export default function JourneyLastMinutePremiumAlert() {
  const $ = _c(6);
  const {
    actions,
    isLastMinute,
    hasSurpriseMeAccommodation
  } = useJourneyData();
  const t = useTranslations("journey");
  if (isLastMinute && hasSurpriseMeAccommodation) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Calendar decorative={true} size="large" color="var(--by-color-icon-default)" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== actions.contact || $[2] !== t) {
      t1 = t.rich("last_minute_unavailable", {
        inspirationLink,
        emailLink: contactLink(actions.contact)
      });
      $[1] = actions.contact;
      $[2] = t;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t1) {
      t2 = <div className="px-4 mt-4 mb-4 md:px-0 md:mb-0"><Notification state="info" message={<div className="inline-flex items-start gap-2">{t0}<div className="inline">{t1}</div></div>} /></div>;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  return null;
}